import {useEffect, cloneElement, useRef} from 'react';

import _ from '../../utils/_';
import elementFactory from '../../utils/element';
import carouselFactory from '../../../vendors/bootstrap/components/carousel.js';
import './carousel.scss';

const Carousel = ({children, instanceRef = {}, ...rest}: propTypes) => {
  const target = useRef(null);

  useEffect(() => {
    const $ = elementFactory(document, window);
    const items = $.findAll('.carousel-item', target.current);
    const left = $.find('.carousel-control-prev', target.current);
    const right = $.find('.carousel-control-next', target.current);
    const indicators = $.findAll('[data-slide-to]', target.current);

    const carousel = carouselFactory($, _);
    const instance = carousel(rest, target.current, [...items], left, right, indicators);

    instanceRef.current = instance;

    return () => {
      instance.destroy();
    };
  });

  return cloneElement(children, {ref: target});
};

interface propTypes {
  children: any;
  interval?: number | false;
  pause?: 'hover' | false;
  wrap?: boolean;
  duration?: number;
  onChange?: (from, to) => any;
  instanceRef?: any;
  addSwipeEvent?: boolean;
}

export default Carousel;
